export const ACTIVITIES_EN = {
    'nav.module.activities': 'Activities',
    'nav.activities.mine': 'My day',
    'feed.activities.assigned': 'My activities',
    'feed.activities.assigned.status.call': 'Call',
    'feed.activities.assigned.status.meeting': 'Meeting',
    'feed.activities.assigned.status.task': 'Task',
    'feed.activities.assigned.status.note': 'Note',
    'activities.refusal.limit': 'Ask for 1 to {max} items.',
    'screen.activities.mine.title': 'My day',
    'screen.activities.activity.title': 'Activity',
    'entity.activities.activity': 'Activity',
    'entity.activities.subject': 'follow-up',
    'activities.mine.title': 'My day',
    'activities.mine.lede': 'What is yours to do: overdue first, then today, then what is coming.',
    'activities.mine.empty': 'Nothing is yours to do.',
    'activities.activity.title': 'Activity',
    'activities.activity.monogram': 'Ac',
    'activities.subject_activities.title': 'Activities',
    'activities.party_activities.title': 'Activities',
    'activities.stat.overdue': 'Overdue',
    'activities.stat.today': 'Today',
    'activities.stat.upcoming': 'Upcoming',
    'activities.kind.call': 'Call',
    'activities.kind.meeting': 'Meeting',
    'activities.kind.task': 'Task',
    'activities.kind.note': 'Note',
    'activities.status.planned': 'Open',
    'activities.status.done': 'Done',
    'activities.status.cancelled': 'Cancelled',
    'activities.due_state.overdue': 'Overdue',
    'activities.due_state.today': 'Today',
    'activities.due_state.upcoming': 'Upcoming',
    'activities.due_state.unscheduled': 'No date',
    'activities.col.title': 'Activity',
    'activities.col.kind': 'Type',
    'activities.col.subject_label': 'On',
    'activities.col.due_on': 'Due',
    'activities.col.due_time': 'At',
    'activities.col.due_state': 'When',
    'activities.col.status': 'Status',
    'activities.col.assignee_name': 'Assigned to',
    'activities.col.assignee_party': 'Person',
    'activities.col.notes': 'Notes',
    'activities.col.outcome': 'Outcome',
    'activities.col.done_at': 'Done',
    'activities.col.cancelled_at': 'Cancelled',
    'activities.col.cancel_reason': 'Reason',
    'activities.col.created_at': 'Recorded',
    'activities.col.subject_entity': 'Record type',
    'activities.col.subject_id': 'Record',
    'activities.col.id': 'Id',
    'activities.col.can_edit': 'Can be edited',
    'activities.col.can_complete': 'Can be marked done',
    'activities.col.can_cancel': 'Can be cancelled',
    'activities.col.can_reopen': 'Can be reopened',
    'activities.field.kind': 'Type',
    'activities.field.title': 'What',
    'activities.field.due_on': 'Due on',
    'activities.field.due_on.help': 'Required for a meeting; a note has none.',
    'activities.field.due_time': 'At',
    'activities.field.assignee_user': 'Assigned to',
    'activities.field.assignee_user.help': 'Empty: you.',
    'activities.field.notes': 'Notes',
    'activities.field.outcome': 'Outcome',
    'activities.field.outcome.help': 'What came of it.',
    'activities.field.reason': 'Reason',
    'activities.action.add': 'Add activity',
    'activities.action.log_call': 'Log a call',
    'activities.field.call_title': 'What about',
    'activities.refusal.logged_call': 'A logged call happened now, and was made by you: it takes no day and no assignee.',
    'activities.action.complete': 'Mark done',
    'activities.action.edit': 'Edit',
    'activities.action.cancel': 'Cancel activity',
    'activities.action.reopen': 'Reopen',
    'activities.card.notes': 'Notes',
    'activities.card.notes.empty': 'No notes.',
    'activities.card.outcome': 'Outcome',
    'activities.card.cancelled': 'Cancelled',
    'activities.card.empty': 'No activity yet.',
    // ── refusals ──
    'activities.refusal.subject': 'The record is named as module.entity and an id.',
    'activities.refusal.subject_required': 'Say which record the activity is about.',
    'activities.refusal.subject_fixed': 'An activity stays on the record it was written on.',
    'activities.refusal.title_required': 'Say what the activity is.',
    'activities.refusal.outcome_required': 'Say what came of it.',
    'activities.refusal.not_text': 'This must be text.',
    'activities.refusal.too_long': 'This is longer than {max} characters.',
    'activities.refusal.day': 'This is not a day.',
    'activities.refusal.time': 'This is not an hour.',
    'activities.refusal.kind': 'Choose a call, a meeting, a task or a note.',
    'activities.refusal.assignee': 'Choose a member of this workspace.',
    'activities.refusal.assignee_name_required': 'The members could not be read here: say whom it is for by name.',
    'activities.refusal.note_undated': 'A note records something; it is due on no day.',
    'activities.refusal.due_on_required': 'A meeting takes place on a day: choose it.',
    'activities.refusal.time_needs_day': 'An hour is on a day: choose the day first.',
    'activities.refusal.to_note': 'A planned activity does not become a note.',
    'activities.refusal.from_note': 'A note stays a note: plan a new activity instead.',
    'activities.refusal.not_found': 'No such activity among those you may see.',
    'activities.refusal.not_planned': 'Only an open activity can be changed this way.',
    'activities.refusal.not_closed': 'Only a done or cancelled activity is reopened.',
    'activities.refusal.not_yours': 'This activity is somebody else\'s: its assignee or a manager marks it done.',
    'activities.refusal.stale': 'The activity changed since you opened it. Reload and try again.',
    'activities.refusal.entity': 'Name the kind of record as module.entity.',
    'activities.refusal.ids': 'Name 1 to {max} records, separated by commas.',
    'activities.refusal.entities': 'Name 1 to {max} kinds of record, separated by commas.',
    'activities.refusal.period': 'The period runs forward, {max} days at most.',
    // ── what the change record keeps ──
    'change.field.activity.kind': 'Type',
    'change.field.activity.subject_entity': 'Record type',
    'change.field.activity.subject_id': 'Record',
    'change.field.activity.subject_label': 'On',
    'change.field.activity.title': 'Activity',
    'change.field.activity.notes': 'Notes',
    'change.field.activity.assignee_user': 'Assigned to (user)',
    'change.field.activity.assignee_party': 'Assigned to (person)',
    'change.field.activity.assignee_name': 'Assigned to',
    'change.field.activity.due_on': 'Due on',
    'change.field.activity.due_time': 'At',
    'change.field.activity.status': 'Status',
    'change.field.activity.outcome': 'Outcome',
    'change.field.activity.done_at': 'Done',
    'change.field.activity.done_by': 'Done by',
    'change.field.activity.done_by_party': 'Done by (person)',
    'change.field.activity.cancelled_at': 'Cancelled',
    'change.field.activity.cancelled_by': 'Cancelled by',
    'change.field.activity.cancel_reason': 'Reason for cancelling',
    'change.field.activity.created_by_party': 'Recorded by (person)',
    'change.field.activity.created_by': 'Recorded by',
};
export const ACTIVITIES_AR = {
    'nav.module.activities': 'الأنشطة',
    'nav.activities.mine': 'يومي',
    'feed.activities.assigned': 'أنشطتي',
    'feed.activities.assigned.status.call': 'مكالمة',
    'feed.activities.assigned.status.meeting': 'اجتماع',
    'feed.activities.assigned.status.task': 'مهمة',
    'feed.activities.assigned.status.note': 'ملاحظة',
    'activities.refusal.limit': 'اطلب من 1 إلى {max} بندًا.',
    'screen.activities.mine.title': 'يومي',
    'screen.activities.activity.title': 'نشاط',
    'entity.activities.activity': 'نشاط',
    'entity.activities.subject': 'المتابعة',
    'activities.mine.title': 'يومي',
    'activities.mine.lede': 'ما عليك إنجازه: المتأخر أولاً، ثم ما موعده اليوم، ثم القادم.',
    'activities.mine.empty': 'لا شيء عليك إنجازه.',
    'activities.activity.title': 'نشاط',
    'activities.activity.monogram': 'ن',
    'activities.subject_activities.title': 'الأنشطة',
    'activities.party_activities.title': 'الأنشطة',
    'activities.stat.overdue': 'متأخرة',
    'activities.stat.today': 'اليوم',
    'activities.stat.upcoming': 'قادمة',
    'activities.kind.call': 'مكالمة',
    'activities.kind.meeting': 'اجتماع',
    'activities.kind.task': 'مهمة',
    'activities.kind.note': 'ملاحظة',
    'activities.status.planned': 'مفتوح',
    'activities.status.done': 'منجز',
    'activities.status.cancelled': 'ملغى',
    'activities.due_state.overdue': 'متأخر',
    'activities.due_state.today': 'اليوم',
    'activities.due_state.upcoming': 'قادم',
    'activities.due_state.unscheduled': 'بلا موعد',
    'activities.col.title': 'النشاط',
    'activities.col.kind': 'النوع',
    'activities.col.subject_label': 'على',
    'activities.col.due_on': 'الموعد',
    'activities.col.due_time': 'الساعة',
    'activities.col.due_state': 'متى',
    'activities.col.status': 'الحالة',
    'activities.col.assignee_name': 'المكلَّف',
    'activities.col.assignee_party': 'الشخص',
    'activities.col.notes': 'ملاحظات',
    'activities.col.outcome': 'النتيجة',
    'activities.col.done_at': 'أُنجز',
    'activities.col.cancelled_at': 'أُلغي',
    'activities.col.cancel_reason': 'السبب',
    'activities.col.created_at': 'سُجّل',
    'activities.col.subject_entity': 'نوع السجل',
    'activities.col.subject_id': 'السجل',
    'activities.col.id': 'المعرّف',
    'activities.col.can_edit': 'يمكن تعديله',
    'activities.col.can_complete': 'يمكن إنجازه',
    'activities.col.can_cancel': 'يمكن إلغاؤه',
    'activities.col.can_reopen': 'يمكن إعادة فتحه',
    'activities.field.kind': 'النوع',
    'activities.field.title': 'ما النشاط',
    'activities.field.due_on': 'الموعد',
    'activities.field.due_on.help': 'مطلوب للاجتماع، ولا موعد للملاحظة.',
    'activities.field.due_time': 'الساعة',
    'activities.field.assignee_user': 'المكلَّف',
    'activities.field.assignee_user.help': 'إن تُرك فارغاً فهو أنت.',
    'activities.field.notes': 'ملاحظات',
    'activities.field.outcome': 'النتيجة',
    'activities.field.outcome.help': 'ما الذي انتهى إليه.',
    'activities.field.reason': 'السبب',
    'activities.action.add': 'إضافة نشاط',
    'activities.action.log_call': 'سجّل مكالمة',
    'activities.field.call_title': 'بخصوص',
    'activities.refusal.logged_call': 'المكالمة المسجَّلة جرت الآن وأجريتَها أنت: لا تأخذ يومًا ولا مكلَّفًا.',
    'activities.action.complete': 'تم الإنجاز',
    'activities.action.edit': 'تعديل',
    'activities.action.cancel': 'إلغاء النشاط',
    'activities.action.reopen': 'إعادة فتح',
    'activities.card.notes': 'ملاحظات',
    'activities.card.notes.empty': 'لا ملاحظات.',
    'activities.card.outcome': 'النتيجة',
    'activities.card.cancelled': 'أُلغي',
    'activities.card.empty': 'لا نشاط بعد.',
    // ── refusals ──
    'activities.refusal.subject': 'يُسمّى السجل بالوحدة والكيان ثم المعرّف.',
    'activities.refusal.subject_required': 'حدّد السجل الذي يخصّه النشاط.',
    'activities.refusal.subject_fixed': 'يبقى النشاط على السجل الذي كُتب عليه.',
    'activities.refusal.title_required': 'اكتب ما النشاط.',
    'activities.refusal.outcome_required': 'اكتب ما الذي انتهى إليه.',
    'activities.refusal.not_text': 'يجب أن يكون هذا نصاً.',
    'activities.refusal.too_long': 'هذا أطول من {max} حرفاً.',
    'activities.refusal.day': 'هذا ليس تاريخاً صحيحاً.',
    'activities.refusal.time': 'هذه ليست ساعة صحيحة.',
    'activities.refusal.kind': 'اختر مكالمة أو اجتماعاً أو مهمة أو ملاحظة.',
    'activities.refusal.assignee': 'اختر عضواً في هذه المساحة.',
    'activities.refusal.assignee_name_required': 'تعذّرت قراءة الأعضاء هنا: اذكر اسم المكلَّف.',
    'activities.refusal.note_undated': 'الملاحظة تسجّل أمراً ولا موعد لها.',
    'activities.refusal.due_on_required': 'للاجتماع يوم يُعقد فيه: اختره.',
    'activities.refusal.time_needs_day': 'الساعة في يوم: اختر اليوم أولاً.',
    'activities.refusal.to_note': 'النشاط المفتوح لا يصبح ملاحظة.',
    'activities.refusal.from_note': 'تبقى الملاحظة ملاحظة: أضف نشاطاً جديداً بدلاً من ذلك.',
    'activities.refusal.not_found': 'لا نشاط كهذا بين ما يحق لك رؤيته.',
    'activities.refusal.not_planned': 'لا يُغيَّر هكذا إلا النشاط المفتوح.',
    'activities.refusal.not_closed': 'لا يُعاد فتح إلا النشاط المنجز أو الملغى.',
    'activities.refusal.not_yours': 'هذا النشاط لغيرك: يُنجزه المكلَّف به أو من يدير الأنشطة.',
    'activities.refusal.stale': 'تغيّر النشاط منذ فتحته. أعد التحميل وحاول مجدداً.',
    'activities.refusal.entity': 'سمِّ نوع السجل بالوحدة ثم الكيان.',
    'activities.refusal.ids': 'سمِّ من سجل واحد إلى {max} سجلًا، تفصل بينها فواصل.',
    'activities.refusal.entities': 'سمِّ من نوع واحد إلى {max} أنواع من السجلات، تفصل بينها فواصل.',
    'activities.refusal.period': 'تبدأ المدة قبل نهايتها، ولا تزيد على {max} يومًا.',
    // ── what the change record keeps ──
    'change.field.activity.kind': 'النوع',
    'change.field.activity.subject_entity': 'نوع السجل',
    'change.field.activity.subject_id': 'السجل',
    'change.field.activity.subject_label': 'على',
    'change.field.activity.title': 'النشاط',
    'change.field.activity.notes': 'ملاحظات',
    'change.field.activity.assignee_user': 'المكلَّف (المستخدم)',
    'change.field.activity.assignee_party': 'المكلَّف (الشخص)',
    'change.field.activity.assignee_name': 'المكلَّف',
    'change.field.activity.due_on': 'الموعد',
    'change.field.activity.due_time': 'الساعة',
    'change.field.activity.status': 'الحالة',
    'change.field.activity.outcome': 'النتيجة',
    'change.field.activity.done_at': 'أُنجز',
    'change.field.activity.done_by': 'أنجزه',
    'change.field.activity.done_by_party': 'أنجزه (الشخص)',
    'change.field.activity.cancelled_at': 'أُلغي',
    'change.field.activity.cancelled_by': 'ألغاه',
    'change.field.activity.cancel_reason': 'سبب الإلغاء',
    'change.field.activity.created_by_party': 'سجّله (الشخص)',
    'change.field.activity.created_by': 'سجّله',
};
//# sourceMappingURL=i18n-activities.js.map